// extracted by mini-css-extract-plugin
export default {"loadingContainer":"MiniLoading_loadingContainer__f55RE","spinner":"MiniLoading_spinner__Lwg+v"};